import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { DepartmentSupportingDocumentsConfiguration } from '../../type/court';
/**
 * Represents a department of a court system
 */
export class Department {
}
__decorate([
    Type(() => DepartmentSupportingDocumentsConfiguration),
    __metadata("design:type", DepartmentSupportingDocumentsConfiguration)
], Department.prototype, "transcriptSupportingDocuments", void 0);
